import {TemplateRef} from '@angular/core';
import {SortDirection} from '@angular/material/sort';

export enum FilterType {
  None,
  String,
  Boolean,
  Number,
  Date,
  Object
}

export interface TableColumn {
  title: string;
  memberName: string;
  filterMemberName?: string; // If the filter property differs from the memberName then this can be used to ensure filters operate correctly
  sortMemberName?: string; // If the sort property differs from the memberName - serviceName -> id.serviceId (used in compound PK)
  sortable: boolean;
  hideHeading?: boolean;
  filterType: FilterType;
  template?: TemplateRef<any>;
  headerTemplate?: TemplateRef<any>;
  excludeFromExport?: boolean;
  sticky?: boolean;
  stickyEnd?: boolean;
  canToggle?: boolean; // This property when false will not show the toggle control
  isVisible?: boolean; // This property when true will show the column in the table
  isDisabled?: boolean; // This property when true will remove the column from the table and the toggle controls - overrides isVisible/canToggle
}

export interface ColumnTemplateContext<T> {
  value: T;
  column: TableColumn;
}

export type CanSelectFunction<T> = (param: T) => boolean;

export interface PagingCriteria {
  sort: string;
  direction: SortDirection;
  pageIndex: number;
  pageSize: number;
}

/**
 * @deprecated Not implemented yet
 */
export interface TableAction<T = void> {
  label: string;
  action: (type: T) => void;
  icon?: string;
  iconClasses?: string[];
  buttonClasses?: string[];
}

export enum TableView {
  Compact = 'compact',
  Comfort = 'comfort'
}

// All properties of T that are either a string, number or Date, that can
// be compared using '<' and '>' operators in the generic sort function
export declare type SortableProperty<T> = Extract<keyof T, string | number | boolean | Date>;

export enum SelectedState {
  SELECTED,
  UNSELECTED
}

export interface SelectionStateModel<T> {
  item: T;
  state: SelectedState;
}

export interface TableRowContextMenuEvent<T> {
  event: MouseEvent;
  item: T;
}